import React from 'react';
import * as constantClass from '../fileWithConstants';
import { createPagedGridController } from '../../hooks/pagedGridClassAdapter';
import * as studentsService from '../../services/students/studentsService';
import { classifyStudentsError } from '../../services/students/studentsDto';
import { LookupModal, LookupSelectButton, LookupActionHeader } from '../common/LookupModal';
import { createLookupSearchHandlers } from '../common/lookupGridSearch';

export class LookupAlumnos extends React.Component {
  constructor(props) {
    super(props);
    this.searchInputRef = React.createRef();
    this.state = {
      show: true,
      loading: true,
      searchInput: '',
      perPage: 5,
      paginationData: [],
      pageCount: 1,
      forcePage: 0,
      showErrorMessage: false,
      errorMessage: '',
    };
    this.grid = createPagedGridController({
      fetchPage: (query) => studentsService.listStudents(query),
      defaultPageSize: 5,
      onChange: (gridState) => this.applyGridState(gridState),
    });
    const searchHandlers = createLookupSearchHandlers(
      this,
      this.grid,
      (error) => this.handleStudentsError(error)
    );
    this.handleSearchInputChange = searchHandlers.handleSearchInputChange;
    this.handleSearchSubmit = searchHandlers.handleSearchSubmit;
  }

  handleModal() {
    this.setState({ show: !this.state.show });
    this.props.hideLookup();
  }

  async componentDidMount() {
    const canAccess = await constantClass.canAccess('WWAlumnos');
    if (canAccess) {
      this.populateData();
    }
  }

  applyGridState(gridState) {
    this.setState({
      paginationData: gridState.items,
      pageCount: gridState.pageCount,
      searchInput: gridState.search,
      perPage: gridState.pageSize,
      loading: gridState.loading,
      forcePage: gridState.forcePage,
      showErrorMessage: Boolean(gridState.error),
      errorMessage: gridState.error?.message ?? '',
    });
  }

  handlePageClick = (e) => {
    this.grid.handlePageClick(e).catch((error) => this.handleStudentsError(error));
  };

  handleItemSelect = (e) => {
    this.props.selectStudent(e);
    this.setState({ show: false });
  };

  renderTable(alumnos) {
    return (
      <table className="md-lookup__table" aria-label={this.props.title || 'Seleccionar el Alumno'}>
        <thead>
          <tr>
            <th scope="col" className="md-lookup__col-dni">DNI</th>
            <th scope="col">Nombre y Apellido</th>
            <LookupActionHeader />
          </tr>
        </thead>
        <tbody>
          {alumnos.map((alumno) => (
            <tr key={alumno.alumnoCodigo}>
              <td className="md-lookup__col-dni">{alumno.alumnoDni}</td>
              <td>{alumno.alumnoNombre}</td>
              <LookupSelectButton
                testId="pick-alumno-lookup"
                onClick={() => this.handleItemSelect(
                  `${alumno.alumnoDni}%${alumno.alumnoNombre}%${alumno.alumnoCodigo}`
                )}
              />
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  render() {
    return (
      <LookupModal
        show={this.state.show}
        onHide={() => this.handleModal()}
        title="Seleccionar el Alumno"
        searchInputRef={this.searchInputRef}
        searchInput={this.state.searchInput}
        searchPlaceholder="Ingrese DNI o Apellido del alumno"
        onSearchInputChange={this.handleSearchInputChange}
        onSearchSubmit={this.handleSearchSubmit}
        loading={this.state.loading}
        errorMessage={this.state.showErrorMessage ? this.state.errorMessage : ''}
        pageCount={this.state.pageCount}
        forcePage={this.state.forcePage}
        onPageChange={this.handlePageClick}
      >
        {this.renderTable(this.state.paginationData)}
      </LookupModal>
    );
  }

  handleStudentsError(error) {
    const outcome = classifyStudentsError(error);
    if (outcome.type === 'timeout') {
      constantClass.RedirectToLogin();
      return;
    }
    this.setState({
      showErrorMessage: true,
      errorMessage: outcome.message,
      loading: false,
    });
  }

  async populateData() {
    try {
      await this.grid.load();
    } catch (error) {
      this.handleStudentsError(error);
    }
  }
}
